import React from 'react'

import { IconProps } from '../../../../types'
import IconWrapper from '../../../IconWrapper'

const ProgressIndicatorSpinnerIconMedium: React.FC<IconProps> = (props) => (
  <IconWrapper {...props}>
    <path d="M8 4.15V7h2V1H8v.004H4v2h2.016a10.998 10.998 0 1 0 17.122 9.136h-2A8.999 8.999 0 1 1 8 4.15ZM18.5 6a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3ZM23 8.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0Z M13.5 4a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3Z" />
  </IconWrapper>
)

export default ProgressIndicatorSpinnerIconMedium
